import { integerBetween, numeric } from '@reliance/forms-js/lib/validation';
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { InputType, TextInput } from '../form/TextInput';

const ConfigurationNetworkFields: React.FC = () => (
  <div className="mt-3">
    <div className="text-muted small mb-1">Network</div>
    <Row>
      <Col md={4}>
        <TextInput
          label="Port"
          name="configuration.network.port"
          type={InputType.number}
          validationRules={[numeric, integerBetween(1, 65535)]}
        />
      </Col>
    </Row>
  </div>
);

export default ConfigurationNetworkFields;
